//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  props: ['isShowHistory'],
  components: {
    Avatar: Avatar
  },
  computed: {
    todayLuckiest: function todayLuckiest() {
      // 领取完之前不展示手气最佳
      if (this.fetcherList.length < 3) return NaN; // 找到天数最多的人的下标

      var maxIndex = 0;

      for (var i = 1; i < this.fetcherList.length; i += 1) {
        maxIndex = this.fetcherList[i].content > this.fetcherList[maxIndex].content ? i : maxIndex;
      }

      if (this.fetcherList[maxIndex].content) {
        return maxIndex;
      } // 全是优惠券，不展示手气最佳


      return NaN;
    }
  }
};